import React, { useState, useEffect, useMemo } from 'react'
import { Col } from 'antd'
import { Marker } from 'react-google-maps'
import { useSelector } from 'react-redux'

import { FullRequestHotel, ResumeHotel } from 'src/types'

import { ApplicationState } from 'src/store'
import { HotelFormFilter } from 'src/components/molecules'
import { useStepsContext } from 'src/views/Requests/views/Form'
import MapContainer from 'src/components/MapContainer'
import StepsNavigation from 'src/views/Requests/views/Form/components/StepsNavigation'

import { WrapRow, WrapCard } from '../../../styles'
import BudgetCard from '../../../Assignment/components/Budget/budget-card'
import HotelsSummaryCard from './components/SummaryCard'
import ModalSelectedHotel from './components/search-result-card/components/ModalSelectedHotel'
import SearchCard from './components/search-card'
import SearchResultCard from './components/search-result-card'

function Hotels(): JSX.Element {
  const {
    hotels: { searches, currentPeriodKey }
  } = useSelector((state: ApplicationState) => ({
    hotels: state.hotels
  }))

  const [selectedHotels, setSelectedHotels] = useState<FullRequestHotel[]>([])
  const [visibleModal, setVisibleModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState<ResumeHotel>()

  const stepsContext = useStepsContext()

  const hasFinishedLoading = useMemo(
    () =>
      Boolean(
        Object.keys(searches).length &&
          Object.values(searches).every(({ loading }) => !loading)
      ),
    [searches]
  )

  const hasHotel = Object.values(searches).some(hotel => hotel.list.length)

  useEffect(() => {
    if (Object.values(searches).some(({ loading }) => loading)) {
      setSelectedHotels([])
    }
  }, [searches])

  return (
    <>
      <StepsNavigation />
      <WrapRow>
        <Col span={15}>
          <SearchCard request={stepsContext.request} />
          {hasFinishedLoading && (
            <SearchResultCard
              request={stepsContext.request}
              selectedHotels={selectedHotels}
              setSelectedHotels={setSelectedHotels}
            />
          )}
        </Col>
        <Col offset={1} span={8}>
          {stepsContext.budgetChartAllocations.active && <BudgetCard />}
          <HotelsSummaryCard
            bodyStyle={{ minHeight: 220 }}
            handleDelete={value => {
              setSelectedHotels(() => [])
              stepsContext.setBudgetAllocations({
                standard_type: 'HOTEL',
                tickets: []
              })
              stepsContext.setRequest({
                ...stepsContext.request,
                full_request_hotel: []
              })
            }}
            request={stepsContext.request}
          />
          {hasHotel && (
            <WrapCard title="web.services.hotels.filters.title">
              <HotelFormFilter />
            </WrapCard>
          )}
          {hasHotel && (
            <WrapCard bodyStyle={{ height: 400 }}>
              <MapContainer>
                {stepsContext.request.request_itineraries.map(item => (
                  <Marker
                    zIndex={2}
                    icon={{
                      url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                    }}
                    key={item.request_itinerary_id}
                    position={{ lat: +item.latitude, lng: +item.longitude }}
                    label={item.activity}
                    // <span
                    //   style={{
                    //     backgroundColor: '#fff',
                    //     border: '1px solid #efefef',
                    //     padding: '4px 8px'
                    //   }}
                    // >
                    //   {item.activity}
                    // </span>
                  />
                ))}
                {currentPeriodKey &&
                  searches[currentPeriodKey].list.map(item => (
                    <Marker
                      zIndex={1}
                      key={item.request_quote_hotel_hash}
                      onClick={() => {
                        setSelectedItem(item)
                        setVisibleModal(true)
                      }}
                      position={{ lat: +item.latitude, lng: +item.longitude }}
                    />
                  ))}
              </MapContainer>
            </WrapCard>
          )}
        </Col>
      </WrapRow>
      <ModalSelectedHotel
        item={selectedItem}
        request={stepsContext.request}
        selectedHotels={selectedHotels}
        setSelectedHotels={setSelectedHotels}
        toggle={() => {
          setSelectedItem(null)
          setVisibleModal(false)
        }}
        visible={visibleModal}
      />
    </>
  )
}

export default Hotels
